import '@/style/index.scss';
import 'element-ui/lib/theme-chalk/base.css';
import 'babel-polyfill';

import App from './App';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import {
  Pagination,
  Carousel,
  CarouselItem,
  Col,
  Row,
  Tree,
  Button,
  Tabs,
  TabPane,
  Collapse,
  CollapseItem,
  // Table,
  // TableColumn,
} from 'element-ui';
import Vue from 'vue';
import router from './router';
import directive from '@/common/tab';

Vue.use(Pagination);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Col);
Vue.use(Row);
Vue.use(Tree);
Vue.use(Button);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Collapse);
Vue.use(CollapseItem);
// Vue.use(Table);
// Vue.use(TableColumn);
Vue.component(CollapseTransition.name, CollapseTransition);
Vue.config.productionTip = false;
Vue.config.performance = true;
Vue.use(directive);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  render: h => h(App),
});
//当前路由跳转页面置顶
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
